module.exports = __webpack_public_path__ + "static/media/image5.b817d669.svg";